import { Icon } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import { List, Item, ItemMore, FoldBar, FoldLabel, FoldText } from "./Styles"

interface FoldableListProps<ItemType> {
  items: Array<ItemType>
  nbItemsToShow: number
  children: (item: ItemType) => JSX.Element
}

const FoldableList = <ItemType,>({ items, nbItemsToShow, children }: FoldableListProps<ItemType>): JSX.Element => {
  const { t } = useTranslation()
  const tooManyItems = items.length > nbItemsToShow
  const [folded, setFolded] = React.useState(tooManyItems)

  const itemsToShow = items.slice(0, folded ? nbItemsToShow : items.length)

  return (
    <List>
      {itemsToShow.map((item, index) => (
        <Item key={index}>{children(item)}</Item>
      ))}

      {tooManyItems && folded && (
        <>
          <Item>
            <ItemMore onClick={() => setFolded(false)} />
          </Item>

          <FoldBar onClick={() => setFolded(false)}>
            <FoldLabel>
              <Icon code={"keyboard_double_arrow_down"} />
              <FoldText>{t("general.show_more")}</FoldText>
            </FoldLabel>
          </FoldBar>
        </>
      )}

      {tooManyItems && !folded && (
        <FoldBar onClick={() => setFolded(true)}>
          <FoldLabel>
            <Icon code={"keyboard_double_arrow_up"} />
            <FoldText>{t("general.show_less")}</FoldText>
          </FoldLabel>
        </FoldBar>
      )}
    </List>
  )
}

export default FoldableList
